import {useEffect} from "react";
import {useSelector} from 'react-redux';
import "./style.css";
import WorkOrderBody from "../../Components/WorkOrderBody";
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";
import SaveStatus from "../../UIComponents/SaveStatus";
import mapStateToProps from './mapStateToProps.js'

const WorkOrder = () => {

    const {
        documentData,
        rights,
        getDocumentData=()=>{},
        setDocumentData=()=>{},
    } = useSelector(mapStateToProps)
    // const rightCheker = (dir, right) => {
    //     const nt = `dir${dir.substring(0, 1).toUpperCase()}${dir.substring(1)}`;
    //     return !!(rights?.[`${nt}-${right}`])
    // }
    const {data:documents=[]} = documentData || {};

    const mapedDocuments=documents?.map((item=[])=>{
        const {
            id,
            number, 
            date,
            company,
            project,
            period,
            status,
            availableStatuses,
            dataArrInc=[], //сырой формат массива данных

         } = item
        
        const dataArr=dataArrInc?.map((works=[])=>{
            const {
                id,
                number, 
                plan,
                workType,
                scope,
                start,
                end,
                processRequirements,
                resultRequirements,
            } = item
            return {
                id:id?.value,
                number:number?.value, 
                plan:plan?.value,
                workType:workType?.value,
                scope:scope?.value,
                start:start?.value,
                end:end?.value,
                processRequirements:processRequirements?.value,
                resultRequirements:resultRequirements?.value,
            }
        })
        return {
            id:id?.value,
            number:number?.value, 
            date:date?.value,
            company:company?.value,
            project:project?.value,
            period:period?.value,
            status:status?.rawValue,
            availableStatuses:availableStatuses?.rawValue,
            dataArrLength:dataArr?.length,
            dataArr
        }
    })

    useEffect(() => {
        // if (dirname && rightCheker(dirname, 'view')) {
            getDocumentData({
                docId: "orderWork"
            })
            return () => {
                if (documentData?.abort) documentData.abort();
                setDocumentData(undefined);
            }
        // }
    }, [])

    // const dirLabel = list.find(({ id }) => id === dirname)
    return (
        <ContentContainer
            content={documentData?.loading?(
                <SaveStatus dataObj={documentData} />
            ):(
                <WorkOrderBody documents={mapedDocuments} rights={rights} />
            )
           }
        />

    )
}

export default WorkOrder
